import React, { createRef, ReactNode, useEffect, useState } from "react";
import Slider from "react-slick";
import YouTubeTakeover from "components/YouTubeTakeover";
import cx from "classnames";
import st from "./index.module.scss";
import SliderText from "./SliderText";
import { useRouter } from "next/router";
import FlavorSlide from "components/FlavorSlide";

export default function HomePageHeroSlider(): JSX.Element {
  const textSliderRef = createRef<Slider>();
  const buttonSliderRef = createRef<Slider>();
  const mainSliderRef = createRef<Slider>();

  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [openVideoModal, setOpenVideoModal] = useState<boolean>(false);
  const [navState, setNavState] = useState<{
    textNav: Slider | undefined;
    buttonNav: Slider | undefined;
    mainNav: Slider | undefined;
  }>({
    textNav: undefined,
    buttonNav: undefined,
    mainNav: undefined,
  });

  const router = useRouter();

  useEffect(() => {
    mainSliderRef.current?.slickPause();
    setNavState({
      textNav: textSliderRef.current || undefined,
      buttonNav: buttonSliderRef.current || undefined,
      mainNav: mainSliderRef.current || undefined,
    });
    setTimeout(
      (slider) => {
        setCurrentIndex(0);
        slider?.slickPlay();
      },
      500,
      mainSliderRef.current
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const appendDots = (dots: ReactNode[]) => <div>{dots}</div>;

  const customPaging = (i: number) => {
    const textClass = cx(st.text, i === currentIndex ? st.activeText : "");

    const renderPaging = () => {
      switch (i) {
        case 0:
          return (
            <p
              className={cx(
                textClass,
                currentIndex === -1 ? st.activeText : ""
              )}
            >
              What&apos;s Next? Find out Now.
            </p>
          );
        case 1:
          return (
            <p className={textClass}>
              {"NEW Recovery\nStrawberry Lemonade is in store and online now!"}
            </p>
          );
        case 2:
          return (
            <p className={textClass}>
              {
                "NEW Strawberry Peach PUNCHED® and Pure Zero is in store & online now!"
              }
            </p>
          );
      }
    };

    return (
      <div className={st.paging}>
        {i === currentIndex ? (
          <div className={st.active} />
        ) : (
          <div className={st.inActive} />
        )}
        <div className={cx(st.textWrapper, st.text)}>{renderPaging()}</div>
      </div>
    );
  };

  const mainSliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 2000,
    fade: true,
    autoplaySpeed: 4000,
    arrows: false,
    centerMode: true,
    centerPadding: "0",
    swipeToSlide: false,
    appendDots: appendDots,
    customPaging: customPaging,
    beforeChange: (_: number, next: number) => setCurrentIndex(next),
  };

  const textSliderSettings = {
    infinite: true,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
  };

  const buttonSliderSettings = {
    dots: false,
    fade: true,
    arrows: false,
  };

  return (
    <div className={st.container}>
      <div className={st.textButtonSlider}>
        <Slider
          ref={textSliderRef}
          asNavFor={navState.mainNav}
          {...textSliderSettings}
          className={st.textSlider}
        >
          <SliderText
            smallHeader="What's Next?"
            largeHeader={
              <>
                Featuring
                <br />
                Angus Cloud
              </>
            }
          />
          <SliderText
            smallHeader="New Flavor!"
            largeHeader={
              <>
                Recovery
                <br />
                Strawberry
                <br />
                Lemonade
              </>
            }
          />
          <SliderText
            smallHeader="New Flavor!"
            largeHeader={
              <>
                Strawberry
                <br />
                Peach
              </>
            }
          />
        </Slider>
        <Slider
          ref={buttonSliderRef}
          asNavFor={navState.textNav}
          {...buttonSliderSettings}
        >
          <button className={st.button} onClick={() => setOpenVideoModal(true)}>
            Watch the video
          </button>
          <button
            onClick={() =>
              router.push("/products/recovery-strawberry-lemonade")
            }
            className={st.button}
          >
            Shop Now
          </button>
          <button
            onClick={() => router.push("/products/pure-zero-strawberry-peach")}
            className={st.button}
          >
            Shop Now
          </button>
        </Slider>
      </div>
      <Slider
        ref={mainSliderRef}
        asNavFor={navState.buttonNav}
        className={st["slick-slider-custom"]}
        {...mainSliderSettings}
      >
        <YouTubeTakeover
          isVideoModalOpen={openVideoModal}
          openVideoModal={() => setOpenVideoModal(true)}
          closeVideoModal={() => setOpenVideoModal(false)}
        />
        <FlavorSlide
          bgImg="https://assets.decovostatic.com/rockstar-energy/assets/images/strawberry-lemonade-hero-bg.svg"
          mobileBgImg="https://assets.decovostatic.com/rockstar-energy/assets/images/strawberry-lemonade-hero-bg-mobile.svg"
          canImg="https://assets.decovostatic.com/rockstar-energy/assets/images/strawberry-lemonade-hero-cans.png"
        />
        <FlavorSlide
          bgImg="https://assets.decovostatic.com/rockstar-energy/assets/images/strawberry-peach-hero-bg.svg"
          canImg="https://assets.decovostatic.com/rockstar-energy/assets/images/strawberry-peach-hero-cans.png"
        />
      </Slider>
    </div>
  );
}
